import { Box, Card } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import type { AppDispatch } from '../../redux/store';
import mixpanel from 'mixpanel-browser';
import Loader from '../../components/Loader';
import { logoutAdmin } from '../../redux/slices/AuthorizationSlice';
import { removeNativeUserFlag } from '../Login/utils/LoginAuthGuard';

const LogoutPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    (async () => {
      mixpanel.reset();
      removeNativeUserFlag();
      await dispatch(logoutAdmin());
    })();
  }, [dispatch]);

  return (
    <Card>
      <Box
        display='flex'
        flexDirection='column'
        justifyContent='center'
        px={4}
        height='100vh'
      >
        <Loader show />
      </Box>
    </Card>
  );
};

export default LogoutPage;
